import { useMemo } from 'react';

/* eslint-disable-next-line */
export interface OptionCicleGroupProps {
  title: string;
  description: string;
  optionsValue: unknown[];
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const OptionsRender = ({
  optionsValue,
  onChange,
}: Pick<OptionCicleGroupProps, 'onChange' | 'optionsValue'>) => {
  const { firstValue, lastValue, firstHalf, lastHalf } = useMemo(
    () => ({
      lastHalf: Math.ceil(optionsValue.length / 2),
      firstHalf: Math.trunc(optionsValue.length / 2),
      firstValue: optionsValue[0],
      lastValue: optionsValue.at(-1),
    }),
    [optionsValue]
  );

  return (
    <div className="flex items-center gap-x-4">
      <span className="text-secondary-400 font-semibold text-xl">
        {firstValue as string}
      </span>
      {[...optionsValue].splice(0, optionsValue.length / 2).map((el, i) => (
        <input
          onChange={onChange}
          id={el as string}
          name="option"
          type="radio"
          className={`h-${8 + (firstHalf - (i + 1)) * 2} w-${
            8 + (firstHalf - (i + 1)) * 2
          } text-secondary-600 bg-secondary-100 border-secondary-300 focus:ring-secondary-500 focus:ring-2 dark:border-secondary-600`}
        />
      ))}
      <input
        onChange={onChange}
        id={optionsValue[firstHalf] as string}
        name="option"
        type="radio"
        className="w-6 h-6 text-gray-600 bg-gray-100 border-gray-300 focus:ring-gray-500 focus:ring-2 dark:border-gray-600"
      />
      {[...optionsValue].splice(lastHalf).map((el, i) => (
        <input
          onChange={onChange}
          id={el as string}
          name="option"
          type="radio"
          className={`h-${8 + i * 2} w-${
            8 + i * 2
          } text-primary-600 bg-primary-100 border-primary-300 focus:ring-primary-500 focus:ring-2 dark:border-primary-600`}
        />
      ))}
      <span className="text-primary-400 font-semibold text-xl">
        {lastValue as string}
      </span>
    </div>
  );
};

export function OptionCicleGroup(props: OptionCicleGroupProps) {
  const { title, description, optionsValue, onChange } = props;
  return (
    <div className="inline-flex flex-col border rounded-lg shadow-sm p-6">
      <label className="text-xl font-medium text-black">{title}</label>
      <p className="px-2 py-4 text-base leading-5 text-gray-800">
        {description}
      </p>
      <fieldset className="mx-auto my-4">
        <legend className="sr-only">Notification method</legend>
        <OptionsRender {...{ optionsValue }} onChange={onChange} />
      </fieldset>
    </div>
  );
}

export default OptionCicleGroup;
